import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ClientActionCard.css';

const ClientActionCard = ({ icon, iconBgColor, title, description, hoverDetails, onClick }) => {
  return (
    <div
      className="client-action-card"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : -1}
    >
      <div className="action-card-content">
        <div className="action-card-icon-container" style={{ backgroundColor: iconBgColor }}>
          <FontAwesomeIcon icon={icon} className="action-card-icon" />
        </div>
        <div className="action-card-details">
          <div className="action-card-title">{title}</div>
          <div className="action-card-description">{description}</div>
        </div>
      </div>
      
      {hoverDetails && (
        <div className="action-card-hover-details">
          {hoverDetails.map((detail, index) => (
            <div key={index} className="hover-detail-item">
              <span className="hover-detail-dot">•</span> {detail}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientActionCard;
